import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
const resources = {
    en: {
        translation: translationEN,
    },
    es: {
        translation: translationES,
    },
};
function getLanguage(cookieDomain) {
    const defaultOptions = {
        ns: ['translation'],
        defaultNS: 'translation',
        load: 'languageOnly',
        supportedLngs: ['en', 'es'],
        whitelist: ['en', 'es'],
        resources,
        fallbackLng: 'en', // use en if detected lng is not available
        // order and from where user language should be detected
        order: ['querystring', 'localStorage', 'sessionStorage', 'cookie', 'navigator', 'htmlTag', 'path', 'subdomain'],
        // keys or params to lookup language from
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        lookupFromPathIndex: 0,
        lookupFromSubdomainIndex: 0,
        // cache user language on
        caches: ['localStorage', 'cookie'],
        // excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
        // optional expire and domain for set cookie
        cookieMinutes: 1000,
        cookieDomain,
        // optional htmlTag with lang attribute, the default is:
        htmlTag: document.documentElement,
        useCookie: true,
        useLocalStorage: true,
        // optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
        cookieOptions: { path: '/', sameSite: 'strict' },
    };
    const languageDetector = new LanguageDetector(null, defaultOptions);
    i18n
        .use(languageDetector)
        .use(initReactI18next)
        .init({
        fallbackLng: 'en',
        // debug: true,
        debug: false,
        load: 'languageOnly',
        supportedLngs: ['en', 'es'],
        resources,
        ns: ['translation'],
        defaultNS: 'translation',
        interpolation: {
            escapeValue: false,
        },
        detection: defaultOptions,
    });
    return i18n;
}
export default getLanguage;
